export default __webpack_public_path__ + "static/media/upload.875ce21d.svg";